import { Button, PlusIcon } from "melco-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AddDesignMappingFormModal } from "./AddDesignMappingFormModal";

export const AddDesignMappingButton: React.FC = () => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        key="design-mapping-add"
        type="primary"
        icon={<PlusIcon />}
        onClick={() => setIsModalOpen(true)}
      >
        {t("designMappings.actions.add.button")}
      </Button>
      <AddDesignMappingFormModal
        isModalOpen={isModalOpen}
        setModalOpen={setIsModalOpen}
      />
    </>
  );
};
